
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import NodeFormMixin from '../forms/NodeFormMixin';
import { AdvancedSearchController } from 'rt/UIApiControllers/AdvancedSearch/AdvancedSearchController';
import { IFlowTemplateDTO } from 'dto/IFlowTemplateDTO';

@Component({
  name: 'BoSummary',
})
export default class BoSummary extends NodeFormMixin {
  @Prop() flow: IFlowTemplateDTO;

  description: string = null;

  async mounted() {
    await this.loadDescriptions();
  }

  @Watch('data')
  async handleDataChanges() {
    await this.loadDescriptions();
  }

  async loadDescriptions() {
    if (this.data.action.changeProperties != null && this.data.action.boType != null) {
      const description = [];

      const startupType = this.startupTypes.find((st) => st.type === this.data.action.boType);
      if (startupType) {
        for (const prop of this.data.action.changeProperties) {
          const currentProp = startupType.properties.find((p) => p.name === prop.name);
          if (currentProp) {
            description.push(currentProp.resName);
          }
        }
      }
      this.description = description.join(', ');
    } else this.description = null;
  }

  get hasConditions(): boolean {
    if (!this.data.action) {
      return false;
    }
    return this.data.action.boType != null && this.data.action.changeProperties && this.data.action.changeProperties.length;
  }
}
